export default [
    {
        path: "acciones-movimientos/traslados",
        name: "traslados",
        component: () =>
            import(
                /* webpackChunkName: "rolesList" */ "./views/SolicitudesView.vue"
                ),
    },
     {
        path: "acciones-movimientos/traslados-permutas",
        name: "trasladosPermutas",
        component: () =>
            import(
                /* webpackChunkName: "rolesList" */ "./views/TrasladosPermutasView.vue"
                ),
    },
    {
        path: "validar-documento/:uuid",
        name: "validardocumento",
        requiresAuth: false,
        component: () =>
            import(
                /* webpackChunkName: "rolesList" */ "./views/ValidarDocumento.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/solicitud/:tipo",
        name: "trasladosCreate",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/CrearTraslado.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/editar-solicitud/:id",
        name: "trasladosEdit",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/EditarTraslado.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/solicitud/view/:id",
        name: "trasladosView",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/solicitudTraslado.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/peticiones/:id",
        name: "trasladoPeticiones",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/solicitudTraslado.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/autorizaciones/:id",
        name: "trasladoAutorizaciones",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/solicitudTraslado.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/visualizar-traslado/:id?",
        name: "trasladoVisualizaciones",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/visualizarTraslado.vue"
                ),
    },
    {
        path: "acciones-movimientos/traslados/visualizar-traslado-destino/:id?",
        name: "trasladoVisualizacionesDestino",
        component: () =>
            import(
                /* webpackChunkName: "rolesCreate" */ "./views/VisualizarTrasladoDestino.vue"
                ),
    },
]